/**
 * Collection of supported identity providers.
 */
export enum IdentityProviders {
    EKEY,
    UNIC,
}

/**
 * Helper that determines which identity provider a given user id is
 * associated with.
 *
 * This works based on the assumption that all ids from Gyldendal's E-key
 * provider takes the form of an e-mail-address.
 */
export function determineIdentityProviderById(userId: string): IdentityProviders {
    return userId.match(/.+\@.+\..+/) ?
        IdentityProviders.EKEY :
        IdentityProviders.UNIC;
}
